var _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.821,
    x2: 459.531,
    y1: 336.331,
    y2: 84.774
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcfdee",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6288,
    stopColor: "#d2f3e4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.074 295.943c18.727 64.003 72.707 194.564 163.922 182.845 91.486-11.755 55.759-129.725 139.508-145.894 36.867-7.118 61.857 56.689 98.806 54.704 47.588-2.557 71.81-49.663 85.108-89.264 28.197-83.968-14.029-226.352-112.859-251.012-86.244-21.519-96.332 83.855-171.322 53.248-42.149-17.203-37.938-68.576-89.272-78.942-155.298-31.359-138.81 189.15-113.891 274.315z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350.232 493.402h-188.464c-16.569 0-30-13.431-30-30v-380.679c0-16.569 13.431-30 30-30h188.464c16.569 0 30 13.431 30 30v380.678c0 16.569-13.431 30.001-30 30.001z",
    fill: "#2626bc",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.232 469.402h-188.464c-16.569 0-30-13.431-30-30v-380.679c0-16.569 13.431-30 30-30h188.464c16.569 0 30 13.431 30 30v380.678c0 16.569-13.431 30.001-30 30.001z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.77 71.632h248.46v354.86h-248.46z",
    fill: "#2d58e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.225 201.915h-50.943c-5.523 0-10-4.477-10-10v-47.011c0-5.523 4.477-10 10-10h50.943c5.523 0 10 4.477 10 10v47.011c0 5.523-4.477 10-10 10z",
    fill: "#1f50c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.144 201.633h-50.943c-5.523 0-10-4.477-10-10v-47.011c0-5.523 4.477-10 10-10h50.943c5.523 0 10 4.477 10 10v47.011c0 5.523-4.477 10-10 10z",
    fill: "#1f50c9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m379.948 134.622v67.01h-21.55c-5.52 0-10-4.48-10-10v-47.01c0-5.52 4.48-10 10-10z",
    fill: "#1f50c9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m309.84 93.061h-107.68c-2.761 0-5 2.239-5 5s2.239 5 5 5h107.68c2.761 0 5-2.239 5-5s-2.238-5-5-5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m239.225 191.403h-50.943c-5.523 0-10-4.477-10-10v-47.011c0-5.523 4.477-10 10-10h50.943c5.523 0 10 4.477 10 10v47.011c0 5.523-4.477 10-10 10z",
    fill: "#ff7eb8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m228.594 170.507h-20.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h20.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.594 154.177h-5.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h5.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m324.144 191.122h-50.943c-5.523 0-10-4.477-10-10v-47.012c0-5.523 4.477-10 10-10h50.943c5.523 0 10 4.477 10 10v47.011c0 5.523-4.477 10.001-10 10.001z",
    fill: "#02ffb3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m313.513 170.226h-20.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h20.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.513 153.895h-5.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h5.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m379.948 124.111v67.01h-21.55c-5.52 0-10-4.48-10-10v-47.01c0-5.52 4.48-10 10-10z",
    fill: "#9fb0fe"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m131.77 426.492v-184.74c0-13.8 11.19-25 25-25h198.46c13.81 0 25 11.2 25 25v184.74z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.232 474.401h-188.464c-19.299 0-35-15.701-35-35v-380.677c0-19.299 15.701-35 35-35h188.464c19.299 0 35 15.701 35 35v380.678c0 19.298-15.701 34.999-35 34.999zm-188.464-440.677c-13.785 0-25 11.215-25 25v380.678c0 13.785 11.215 25 25 25h188.464c13.785 0 25-11.215 25-25v-380.678c0-13.785-11.215-25-25-25z",
    fill: "#2626bc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m273.483 56.094h-34.966c-2.761 0-5-2.239-5-5s2.239-5 5-5h34.966c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#b7c5ff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 296.813,
    cy: 51.092,
    fill: "#b7c5ff",
    r: 5.002
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m234.594 249.062h-20.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h20.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#00d890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.594 269.335h-122.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h122.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#9fb0fe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m184.926 279.335h-20.272c-2.761 0-5-2.239-5-5v-20.272c0-2.761 2.239-5 5-5h20.272c2.761 0 5 2.239 5 5v20.272c0 2.761-2.239 5-5 5z",
    fill: "#02ffb3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m234.594 311.006h-20.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h20.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#ff5ba8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.594 331.278h-122.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h122.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#9fb0fe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m184.926 341.278h-20.272c-2.761 0-5-2.239-5-5v-20.272c0-2.761 2.239-5 5-5h20.272c2.761 0 5 2.239 5 5v20.272c0 2.761-2.239 5-5 5z",
    fill: "#ff7eb8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m234.594 372.949h-20.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h20.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.594 393.221h-122.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h122.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#9fb0fe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m184.926 403.221h-20.272c-2.761 0-5-2.239-5-5v-20.272c0-2.761 2.239-5 5-5h20.272c2.761 0 5 2.239 5 5v20.272c0 2.761-2.239 5-5 5z",
    fill: "#9fb0fe"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m418.336 397.24c-7.88 0-14.291-6.411-14.291-14.292s6.411-14.292 14.291-14.292 14.291 6.411 14.291 14.292-6.411 14.292-14.291 14.292zm0-18.583c-2.366 0-4.291 1.925-4.291 4.292s1.925 4.292 4.291 4.292 4.291-1.925 4.291-4.292-1.925-4.292-4.291-4.292z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.919 184.409c-2.761 0-5-2.239-5-5 0-3.309-2.691-6-6-6-2.761 0-5-2.239-5-5s2.239-5 5-5c3.309 0 6-2.691 6-6 0-2.761 2.239-5 5-5s5 2.239 5 5c0 3.309 2.691 6 6 6 2.761 0 5 2.239 5 5s-2.239 5-5 5c-3.309 0-6 2.691-6 6 0 2.761-2.239 5-5 5z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.652 442.493c-2.762 0-5-2.239-5-5 0-3.309-2.691-6-6-6-2.762 0-5-2.239-5-5s2.238-5 5-5c3.309 0 6-2.691 6-6 0-2.761 2.238-5 5-5s5 2.239 5 5c0 3.309 2.691 6 6 6 2.762 0 5 2.239 5 5s-2.238 5-5 5c-3.309 0-6 2.691-6 6 0 2.761-2.238 5-5 5z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff5ba8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m443.652 150.622c-2.762 0-5-2.239-5-5 0-3.309-2.691-6-6-6-2.762 0-5-2.239-5-5s2.238-5 5-5c3.309 0 6-2.691 6-6 0-2.761 2.238-5 5-5s5 2.239 5 5c0 3.309 2.691 6 6 6 2.762 0 5 2.239 5 5s-2.238 5-5 5c-3.309 0-6 2.691-6 6 0 2.761-2.238 5-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.627 233.706c-2.761 0-5-2.239-5-5 0-3.309-2.691-6-6-6-2.761 0-5-2.239-5-5s2.239-5 5-5c3.309 0 6-2.691 6-6 0-2.761 2.239-5 5-5s5 2.239 5 5c0 3.309 2.691 6 6 6 2.761 0 5 2.239 5 5s-2.239 5-5 5c-3.309 0-6 2.691-6 6 0 2.761-2.238 5-5 5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.0cb7ef4abe91acb7949e3e2651c8baa1.svg";
export { ForwardRef as ReactComponent };